function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icon",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2002 0C15.723 0 20.2002 4.47715 20.2002 10C20.2002 15.5228 15.723 20 10.2002 20C4.67735 20 0.200195 15.5228 0.200195 10C0.200195 4.47715 4.67735 0 10.2002 0ZM15.9073 6.29289C15.5468 5.93241 14.9796 5.90468 14.5873 6.2097L14.4931 6.29289L9.2002 11.585L7.9073 10.2929L7.81309 10.2097C7.4208 9.90468 6.85357 9.93241 6.49309 10.2929C6.1326 10.6534 6.10487 11.2206 6.4099 11.6129L6.49309 11.7071L8.49309 13.7071L8.5873 13.7903C8.9469 14.0699 9.4535 14.0699 9.8131 13.7903L9.9073 13.7071L15.9073 7.70711L15.9905 7.6129C16.2955 7.22061 16.2678 6.65338 15.9073 6.29289Z",
  fill: "#2C9C3B"
});

function SvgCheckmarkCircleGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleGreen);
export default __webpack_public_path__ + "static/media/checkmark-circle-green.8f684389.svg";
export { ForwardRef as ReactComponent };